import { Flex, Badge, HStack, Button } from "@chakra-ui/react";
import ScreeningTable from "./ScreeningTable";
import { Activity } from "lucide-react";

const Screening = () => {
  const DowJonesIcon = () => {
    return (
      <svg
        id="svg2"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 66.8 80"
        height={"12px"}
        width={"12px"}>
        <g id="layer1">
          <g id="g3556">
            <path
              id="path3529"
              style={{ fill: "#13a3d7" }}
              d="M0,40V0h22l22,.1,1.9.5c9.1,2.3,15.8,8.1,19.1,16.6.8,2,1.5,5.4,1.6,7.5v1.8c.1,0-6.5,0-6.5,0h-6.6v-.9c-.4-2.8-1.3-5.1-2.9-7.2-1.6-2.1-4-3.8-6.7-4.7l-1.4-.5h-14.5l-14.5-.1v53.4h13.3v13.3H0v-40,.2Z"
            />
            <path
              id="path3525"
              style={{ fill: "#13a3d7" }}
              d="M36.8,73.4v-6.6h2.4c1.3-.2,2.9-.4,3.5-.5,3.8-.9,7.5-3.8,9.3-7.3,1.4-2.9,1.4-2.5,1.5-13v-9.4h13.3v10.2l-.1,10.2-.5,1.9c-1.3,5.3-3.6,9.3-7.3,13.1-3,3-6.4,5.2-10.4,6.5-3,1-4.9,1.4-8.5,1.5h-3.2c0,.1,0-6.5,0-6.5h0v-.1Z"
            />
          </g>
        </g>
      </svg>
    );
  };

  return (
    <Flex direction="column" p={0} w={"100%"} gap={{ lg: 16, base: 8 }}>
      <Flex
        justifyContent="space-between"
        direction={{ lg: "row", base: "column" }}
        gap={4}>
        <h1>AML / KYC screening</h1>
        <HStack>
          <Badge size={"sm"}>Last screening: Today, 8:00</Badge>
          <Button size={"md"} leftIcon={<Activity />}>
            Screen now
          </Button>{" "}
        </HStack>
      </Flex>

      <ScreeningTable DowJonesIcon={DowJonesIcon} />
    </Flex>
  );
};

export default Screening;
